import { ref } from 'vue'

export type ToastTone = 'success' | 'error' | 'info'
export interface Toast { id: number, message: string, tone: ToastTone }

const toasts = ref<Toast[]>([])
let sequence = 0

export function useToast() {
    function show(message: string, tone: ToastTone = 'info') {
        const id = ++sequence
        toasts.value.push({ id, message, tone })
        window.setTimeout(dismiss, 3200, id)
    }

    function dismiss(id: number) {
        toasts.value = toasts.value.filter(toast => toast.id !== id)
    }

    return { toasts, show, dismiss }
}
